import clsx from 'clsx';
import { Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import { SocialMedia as SocialMediaProps } from 'types/studio/studio';
import styles from './SocialMediaHeadlineAndSubtitle.module.scss';

type Props = Pick<SocialMediaProps, 'subtitle' | 'headline' | 'theme'>;

const SocialMediaHeadlineAndSubtitle = (props: Props) => {
  const { subtitle, headline, theme } = props;
  return (
    <Space bottom={{ xxs: 32, sm: 40, m: 48, l: 56 }}>
      {subtitle && (
        <Typography
          variant="subtitle"
          color={getTypographyDefaultColor(theme)}
          size="1"
          noPadding
          className={styles.subtitle}
          weight="700">
          {subtitle}
        </Typography>
      )}
      <Typography
        variant="headlineSans"
        size="2"
        component="h2"
        noPadding
        color={getTypographyDefaultColor(theme)}
        className={clsx(styles.headline, !subtitle && styles.noMargin)}>
        {headline}
      </Typography>
    </Space>
  );
};

export default SocialMediaHeadlineAndSubtitle;
